import { render, staticRenderFns } from "./DetalleReporte.vue?vue&type=template&id=24307e3c&"
import script from "./DetalleReporte.vue?vue&type=script&lang=js&"
export * from "./DetalleReporte.vue?vue&type=script&lang=js&"
import style0 from "./DetalleReporte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports